/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import slugify from 'slugify'
import { useTranslation } from 'react-i18next'

export const StickyCategoriesV2 = ({ categories, isArabic }: { categories: any; isArabic: boolean }) => {
  const [selectedCategory, setSelectedCategory] = useState<{ slug: string; title: string } | null>(null)
  const [searchParams, setSearchParams] = useSearchParams()

  const [showMenu, setShowMenu] = useState(false)
  const { t } = useTranslation()

  const categoriesObjects = categories.map((category: any) => {
    return {
      title: category.category?.attributes?.menu_title || category.category?.attributes?.title,
      slug: slugify(category.category?.attributes?.title, { lower: true })
    }
  })

  // Inverser la liste si c'est en arabe
  if (isArabic) {
    categoriesObjects.reverse()
  }

  useEffect(() => {
    if (!searchParams.get('categorie') || searchParams.get('from')) return
    const matchedCategory = categoriesObjects.find((category: any) => category.slug === searchParams.get('categorie'))
    setSelectedCategory(matchedCategory)

    const stickyCategory = document.querySelector(`#${matchedCategory?.slug}_sticky_element`) as HTMLElement
    stickyCategory?.scrollIntoView({
      inline: 'center',
      block: 'nearest'
    })
  }, [searchParams])

  const handleCategoryClick = (category: any) => {
    if (!category) return
    setShowMenu(false)
    scrollToElement(category.slug)
  }

  useEffect(() => {
    if (searchParams && searchParams.get('categorie')) {
      const query = searchParams.get('categorie')
      console.log('loading category, checking for sticky element with id:', `${query}_sticky_element`)
      setTimeout(() => {
        scrollToElement(query as string)
      }, 60)
    }
  }, [])

  function scrollToElement(elementId: string) {
    console.log('Attempting to scroll to element with ID:', elementId)
    const element = document.getElementById(elementId)
    const container = document.getElementById('main')

    if (!element || !container) {
      // eslint-disable-next-line no-console
      console.warn(`Element with ID ${elementId} not found.`)
      return
    }

    const newParams = new URLSearchParams(searchParams)
    newParams.set('categorie', elementId)
    newParams.set('from', 'click')
    setSearchParams(newParams, { replace: true })

    const headerOffset = document.querySelector('header')?.parentElement?.clientHeight || 112

    // element.getBoundingClientRect() - The size of an element and it's position relative to the viewport
    // window.scrollY -   gives you the scroll position of the document in pixels from the top of the viewport
    const elementPosition = element.getBoundingClientRect().top + container.scrollTop - headerOffset

    container.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    })

    container.addEventListener(
      'scrollend',
      () => {
        const params = new URLSearchParams(window.location.search)
        params.delete('from') // On enlève 'click', le RAF reprend la main
        setSearchParams(params, { replace: true })
      },
      { once: true }
    )
  }

  return (
    <React.Fragment>
      <div
        className={`fixed ${showMenu ? 'block' : 'hidden pointer-events-none'} max-w-[768px] font-mammaTitle max-h-[90vh] grid grid-rows-[1fr_auto] text-primary z-50 bottom-0 left-1/2 -translate-x-1/2 h-auto w-full rounded-t-[6px] bg-white`}
      >
        <div className="grid grid-cols-2 overflow-auto">
          {categoriesObjects.map((category: any, index: number) => (
            <button
              key={index}
              translate="no"
              onClick={() => handleCategoryClick(category)}
              className="border-b border-primary odd:border-r py-7 px-10 flex items-center justify-center text-center text-[12px] uppercase font-bold tracking-[0.02em]"
            >
              {category.title}
            </button>
          ))}
        </div>
        <div className="p-4 border-t border-primary -mt-px">
          <button
            className="w-full flex items-center justify-center text-[12px] uppercase font-bold tracking-[0.02em] bg-primary h-[50px] text-tertiary"
            onClick={() => setShowMenu(false)}
          >
            {t('close')}
          </button>
        </div>
      </div>
      <div
        className={`fixed ${showMenu ? 'block' : 'hidden pointer-events-none'} z-40 bg-black/50 top-0 left-0 w-full h-full cursor-pointer`}
        onClick={() => setShowMenu(false)}
      ></div>
      <div className="sticky font-mammaTitle z-10 flex w-full border-y text-primary border-tertiary ">
        <div id="sticky-header" className="flex w-full overscroll-x-none overflow-x-scroll h-14 hide-scrollbar">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="sticyky left-0 aspect-square h-14 flex items-center justify-center bg-primary text-tertiary border-r border-tertiary sticky left-0"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 5H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 5H4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8 12H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 12H4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8 19H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 19H4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          {categoriesObjects.map((category: any, index: number) => (
            <button
              key={index}
              translate="no"
              id={`${category.slug}_sticky_element`}
              // href={`#${category.slug}`}
              onClick={() => handleCategoryClick(category)}
              className={`uppercase whitespace-nowrap tracking-widest cursor-pointer flex items-center text-[12px] px-4 py-1
                        ${selectedCategory?.slug === category.slug ? 'bg-white text-primary' : 'bg-primary text-tertiary'}
                        border-r border-tertiary border-b border-b-primary`}
            >
              {category.title}
            </button>
          ))}
        </div>
      </div>
    </React.Fragment>
  )
}
